import React from 'react';

const IconBar = () => {
    const [selectedIcon, setSelectedIcon] = React.useState('home');

    const handleIconClick = (icon) => {
        setSelectedIcon(icon === selectedIcon ? null : icon);
        // Redirect to a new page based on the icon
        switch (icon) {
            case 'user':
                window.location.href = '/Profile';
                break;
            case 'chat':
                window.location.href = '/Shown';
                break;
            case 'add':
                window.location.href = '/RegisterAD';
                break;
            case 'headset':
                window.location.href = '/Support';
                break;
            case 'home':
                window.location.href = '/';
                break;
            default:
                break;
        }
    };

    return (

            <div style={{ display: 'flex', position: 'fixed', bottom: '10px', width: '98%', left: '1%', flexDirection: 'row-reverse', justifyContent: 'space-around', alignItems: 'center', padding: '10px', borderRadius: '20px', backgroundColor: '#f5f5f5', color: '#747474', fontSize: '10px',  zIndex: '50' }}>
                <div
                    onClick={() => handleIconClick('user')}
                    style={{
                        height: '33px',
                        padding: '5px',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src={selectedIcon === 'user' ? '/icons/navbar/selected-user-icon.svg' : '/icons/navbar/user-icon.svg'}
                        alt="User"
                        style={{ width: '100%', height: '100%' }}
                    />
                    <div>پروفایل</div>
                </div>
                <div
                    onClick={() => handleIconClick('chat')}
                    style={{
                        height: '33px',
                        padding: '5px',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src={selectedIcon === 'chat' ? '/icons/navbar/selected-chat-icon.svg' : '/icons/navbar/chat-icon.svg'}
                        alt="Chat"
                        style={{ width: '100%', height: '100%' }}
                    />
                    <div>نشان‌شده‌ها</div>
                </div>
                <div
                    onClick={() => handleIconClick('add')}
                    style={{
                        height: '33px',
                        padding: '5px',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src={selectedIcon === 'add' ? '/icons/navbar/selected-add-icon.svg' : '/icons/navbar/add-icon.svg'}
                        alt="Add"
                        style={{ width: '100%', height: '100%' }}
                    />
                    <div>ثبت فایل</div>
                </div>
                <div
                    onClick={() => handleIconClick('headset')}
                    style={{
                        height: '33px',
                        padding: '5px',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src={selectedIcon === 'headset' ? '/icons/navbar/selected-headset-icon.svg' : '/icons/navbar/headset-icon.svg'}
                        alt="Headset"
                        style={{ width: '100%', height: '100%' }}
                    />
                    <div>پشتیبانی</div>
                </div>
                <div
                    onClick={() => handleIconClick('home')}
                    style={{
                        height: '33px',
                        padding: '5px',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        src={selectedIcon === 'home' ? '/icons/navbar/selected-home-icon.svg' : '/icons/navbar/home-icon.svg'}
                        alt="Home"
                        style={{ width: '100%', height: '100%' }}
                    />
                    <div>خانه</div>
                </div>
            </div>
    );
};

export default IconBar;